'use strict';

var ad_link_selector = function () {
  var self = this;

  self.init();
  self.bind();
};


ad_link_selector.prototype.bind = function () {
  var self = this;

  $(document).arrive('.ad_link_selector', function (localSelf) {
    localSelf.init_items();
  }.bind(null, self));

};


ad_link_selector.prototype.init = function () {
  var self = this;

  $(document).on('click', '.ad_link_selector', function(localSelf, event) {
    var element = $(event.currentTarget);

    event.preventDefault();
    event.stopPropagation();      

    localSelf.set_value_to_input(element);
  }.bind(null, self)  );

  self.init_items();

};

ad_link_selector.prototype.set_value_to_input = function (element) {
  var self = this;

  var brothers = element.closest('.ad_link_selector_container').find('.ad_link_selector');
  brothers.removeClass('active');

  element.addClass('active');

  var input_selector = element.data('input');

  $('#'+element.data('input')).val(element.data('value'));
};



ad_link_selector.prototype.init_items = function () {
  var self = this;

  $('.ad_link_selector').each( function (/* index*/) {
      var element = $(this);

      if (element.hasClass('st_mounted') === false) {
        element.addClass('st_mounted');
      }
  });

};



$( document ).ready(function() {

  window.ad_link_selector = new ad_link_selector();

});
